var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHomeOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_140_77132",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.125,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_140_77132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.375 18.9429H8.75V12.7714H15.5V18.9429H18.875V9.68571L12.125 5.05714L5.375 9.68571V18.9429ZM5.375 21C4.75625 21 4.22656 20.7986 3.78594 20.3957C3.34531 19.9929 3.125 19.5086 3.125 18.9429V9.68571C3.125 9.36 3.20469 9.05143 3.36406 8.76C3.52344 8.46857 3.74375 8.22857 4.025 8.04L10.775 3.41143C10.9813 3.27429 11.1969 3.17143 11.4219 3.10286C11.6469 3.03429 11.8812 3 12.125 3C12.3688 3 12.6031 3.03429 12.8281 3.10286C13.0531 3.17143 13.2687 3.27429 13.475 3.41143L20.225 8.04C20.5062 8.22857 20.7266 8.46857 20.8859 8.76C21.0453 9.05143 21.125 9.36 21.125 9.68571V18.9429C21.125 19.5086 20.9047 19.9929 20.4641 20.3957C20.0234 20.7986 19.4938 21 18.875 21H13.25V14.8286H11V21H5.375Z",
    fill: "#40DF9F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeOn);
export default __webpack_public_path__ + "static/media/icon-home-on.ac987799a72e31c4684f23e00b6a30d2.svg";
export { ForwardRef as ReactComponent };